import Cookies from 'js-cookie'

export const COOKIE_BANNER_COOKIE_NAME = 'COOKIE_BANNER_COOKIES_ACCEPTED'

export function parseCookieBannerCookie() {
  const cookieBannerCookieContent = Cookies.get(COOKIE_BANNER_COOKIE_NAME)
  return !!cookieBannerCookieContent && !!JSON.parse(cookieBannerCookieContent)
}
